export default "__VITE_ASSET__BIbBMjtO__"